module.exports = __webpack_public_path__ + "static/media/results-bg.36af3065.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parentreg/results-bg.jpg
// module id = 1059
// module chunks = 0